import { Action } from '../types/routine';

export const AVAILABLE_ACTIONS: Action[] = [
  { id: 'shave', name: 'Shave', description: 'Facial shaving routine' },
  { id: 'cold-plunge', name: 'Cold Plunge', description: 'Cold water therapy for skin' },
  { id: 'roller-massage', name: 'Roller Massage', description: 'Facial roller massage' },
  { id: 'face-yoga', name: 'Face Yoga', description: 'Facial exercises and massage' }
];

export const getActionById = (actionId: string): Action | undefined => {
  return AVAILABLE_ACTIONS.find(action => action.id === actionId);
};

export const getActionIcon = (actionId: string): string => {
  switch (actionId) {
    case 'shave':
      return 'edit'; // Razor-like icon
    case 'cold-plunge':
      return 'refresh'; // Water/cooling icon
    case 'roller-massage':
      return 'adjustments'; // Tool icon
    case 'face-yoga':
      return 'user'; // Face/person icon
    default:
      return 'idea'; // Default icon
  }
};
